module.exports = "<div class=\"sidenav\">\n  <md-sidenav class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\">\n    <md-content layout-padding>\n      <md-list ng-cloak>\n        <md-subheader class=\"md-no-sticky\">Navigate to</md-subheader>\n        <md-list-item ng-click=\"vm.navigateTo(menuItem.state, $event)\" ng-repeat=\"menuItem in vm.menuItems\">\n          <md-icon class=\"material-icons\" ng-class=\"{'md-accent': vm.isActive(menuItem.state)}\">pages</md-icon>\n          <p> {{ menuItem.title }} </p>\n        </md-list-item>\n      </md-list>\n    </md-content>\n  </md-sidenav>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/sidenav/sidenav.html
 ** module id = 23
 ** module chunks = 0
 **/